<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card
        tile
        class="fill-height d-flex flex-column align-center justify-center"
      >
        <v-icon color="primary lighten-4" style="font-size: 256px">
          mdi-cogs
        </v-icon>
        <h1 class="py-5 grey--text text--darken-3">
          Website under maintenance....
        </h1>
        <p class="ma-0 grey--text text--darken-2">
          Our website is currently undergoing scheduled maintenance.
        </p>
        <p class="grey--text text--darken-2">
          We should be back shortly, Thank you for your patience.
        </p>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      dialog: true,
    }
  },
}
</script>
